import { addAuthInterceptors } from '@dentalux/security';
import axios from 'axios';
const http = axios.create({
  baseURL: process.env.NEXT_PUBLIC_PATIENT_URL
});
addAuthInterceptors(http);
export const getBaseProfileImage = async ({
  personReferenceId
}) => {
  const {
    data
  } = await http.get(`/external/persons/${personReferenceId}/profile-images`);
  return data;
};
export const getBaseProfileImageFile = async url => {
  const {
    data
  } = await http.get(url.replace('/api', ''), {
    responseType: 'blob'
  });
  return data;
};
export const getManipulatedProfileImage = async ({
  personReferenceId
}) => {
  const {
    data
  } = await http.get(`/external/persons/${personReferenceId}/profile-images/manipulated`);
  return data;
};
export const postProfileImage = async ({
  personReferenceId,
  formData
}) => {
  const {
    data
  } = await http.post(`/external/persons/${personReferenceId}/profile-images`, formData);
  return data;
};
export const deleteProfileImage = async ({
  personReferenceId,
  profileImageReferenceId
}) => {
  const {
    data
  } = await http.delete(`/external/persons/${personReferenceId}/profile-images/${profileImageReferenceId}`);
  return data;
};
export const postManipulateProfileImage = async ({
  personReferenceId,
  profileImageReferenceId,
  formData
}) => {
  const {
    data
  } = await http.patch(`/external/persons/${personReferenceId}/profile-images/${profileImageReferenceId}`, formData);
  return data;
};
export const updatePersonalData = async ({
  personReferenceId,
  ...body
}) => {
  const {
    data
  } = await http.patch(`/persons/${personReferenceId}/personal-data`, body);
  return data;
};
export const postFavoritePractitioner = async ({
  personReferenceId,
  practitionerReferenceId
}) => {
  const {
    data
  } = await http.post(`/persons/${personReferenceId}/favorite-practitioners?practitionerReferenceId=${practitionerReferenceId}`);
  return data;
};
export const deleteFavoritePractitioner = async ({
  personReferenceId,
  practitionerReferenceId
}) => {
  const {
    data
  } = await http.delete(`/persons/${personReferenceId}/favorite-practitioners`, {
    params: {
      practitionerReferenceId
    }
  });
  return data;
};
export const patchArchieveAnamnesis = async ({
  personReferenceId,
  clinicReferenceId,
  manuallyDeprecated
}) => {
  const {
    data
  } = await http.patch(`external/persons/${personReferenceId}/clinics/${clinicReferenceId}`, {
    manuallyDeprecated
  });
  return data;
};